import { queryOptions } from "@tanstack/react-query"
import { api } from "./api"

// Comms readiness report — can we reach each confirmed guest on push / SMS?
// Server-computed by /comms/report (getEventCommsReport).

export type CommsReportGuest = {
  guestId: string
  displayName: string
  email: string | null
  status: string
  claimed: boolean
  push: { enabled: boolean; guestDevices: number; userDevices: number }
  sms: {
    consent: boolean
    consentAt: string | null
    hasPhone: boolean
    suppressed: boolean
    eligible: boolean
  }
}

export type CommsReport = {
  success: boolean
  eventId: string
  smsEnabled: boolean
  total: number
  pushEnabledCount: number
  pushNotEnabledCount: number
  smsConsentCount: number
  smsEligibleCount: number
  hasPhoneCount: number
  guests: CommsReportGuest[]
}

export function commsReportQueryOptions(eventId: string) {
  return queryOptions({
    queryKey: ["event-comms-report", eventId] as const,
    queryFn: () =>
      api<CommsReport>("/api/v1/comms/report", {
        method: "POST",
        body: { eventId },
      }),
  })
}
